import TimelineModel from "./TimelineModel.js";
import TimelineDataViewer from "./TimelineDataViewer.js";
import TimelineModelEditor from "./TimelineModelEditor.js";
import EditTimelineSettingsAction from "./EditTimelineSettingsAction.js";
import ActionsSetup from "./actions/PluginSetup.js";
export default {
  install(plg) {
    plg.addPlugin('Model', {
      type: TimelineModel.TYPE,
      model: TimelineModel
    });
    plg.addPlugin('ModelEditor', {
      type: TimelineModel.TYPE,
      editor: TimelineModelEditor
    });
    plg.addPlugin('DataViewer', TimelineDataViewer);
    plg.addPlugin('Action', EditTimelineSettingsAction);
    ActionsSetup.install(plg);
  }
};